import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { Contrato } from "../../../base/vo/contrato";
import { Field } from "../../../base/vo/formulario";
import { AdminContratosService } from "../admin-contratos.service";

@Component({
  selector: "app-admin-contratos-visualizar",
  templateUrl: "./admin-contratos-visualizar.component.html",
  styleUrls: ["./admin-contratos-visualizar.component.scss"],
})
export class AdminContratosVisualizarComponent implements OnInit, OnDestroy {
  public loading = false;
  public formGroup: FormGroup;
  private subs: Subscription[] = [];
  private id: number;
  public contrato: Contrato;
  public arquivoVinculoName: string;

  public fields: Field[] = [
    {
      controlName: "titulo",
      label: "Titulo Documento",
    },
    {
      controlName: "observacao",
      label: "Observação",
    },
    {
      controlName: "anexo",
      label: "anexo",
    },
    {
      controlName: "documento",
      label: "Documento",
    },
  ];

  constructor(
    private readonly adminContratoService: AdminContratosService,
    private readonly formBuilder: FormBuilder,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      titulo: [{ value: "", disabled: true }, [Validators.required]],
      observacao: [{ value: "", disabled: true }, [Validators.required]],
      documento: [{ value: "", disabled: true }, [Validators.required]],
    });

    this.subs.push(
      this.route.params
        .pipe(
          tap((params) => {
            if (params["id"]) {
              this.id = +params["id"];
              this.getContrato();
            } else {
              this.loading = false;
            }
          })
        )
        .subscribe()
    );
  }

  getContrato() {
    this.loading = true;

    this.subs.push(
      this.adminContratoService
        .getContrato(this.id)
        .pipe(
          tap(
            (response) => {
              this.contrato = response;
              if (this.contrato.urlAnexoVinculo) {
                this.arquivoVinculoName =
                  this.contrato.urlAnexoVinculo.substring(
                    this.contrato.urlAnexoVinculo.lastIndexOf("/") + 1
                  );
              }
              this.loading = false;
              this.setFields();
            }
          )
        )
        .subscribe()
    );
  }

  private setFields() {
    this.formGroup.controls.titulo.setValue(this.contrato.titulo);
    this.formGroup.controls.observacao.setValue(this.contrato.observacao);
    this.formGroup.controls.documento.setValue(this.contrato.documento);
  }

  downloadCsv() {
    this.loading = true;

    this.subs.push(
      this.adminContratoService
        .downloadCsv(this.contrato.id)
        .pipe(
          tap(
            (response) => {
              const blob = new Blob([response], { type: "text/csv" });
              const url = window.URL.createObjectURL(blob);
              var anchor = document.createElement("a");
              const date = new Date();
              anchor.download = `assinaturas_${this.contrato.titulo.toLowerCase()}_${date.toLocaleDateString()}.csv`;
              anchor.href = url;
              anchor.click();
              this.loading = false;
            }
          )
        )
        .subscribe()
    );
  }

  downloadArquivoVinculo() {
    this.loading = true;

    this.subs.push(
      this.adminContratoService
        .downloadArquivoVinculo(this.contrato.id)
        .pipe(
          tap(
            (response) => {
              const blob = new Blob([response], { type: "text/csv" });
              const url = window.URL.createObjectURL(blob);
              var anchor = document.createElement("a");
              const date = new Date();
              anchor.download = `${this.contrato.urlAnexoVinculo.substring(
                this.contrato.urlAnexoVinculo.lastIndexOf("/") + 1
              )}.xlsx`;
              anchor.href = url;
              anchor.click();
              this.loading = false;
            }
          )
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-visualizar/admin-contratos-visualizar.component.ts